import React, { Fragment } from "react";
import { connect } from "react-redux";
import { showModal, hideModal } from "store/state/modals/modal";
import styled from "styled-components";
import { withRouter } from 'react-router-dom';
import { compose } from "redux";
import { Add } from "@material-ui/icons";
import Button from "@material-ui/core/Button";
const OpenNewDealButton = styled(Button)`
  position: absolute;
  color: #0f9ad6;
  cursor: pointer;

  && {
    display: flex;    
    padding: 8px 8px 8px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
    margin-left: auto;
    justify-content: space-around;
    align-items: center;

  }
  & span {
    margin-left: 4px;
  }
  &&:hover {
    background: #f6f6f6;
  }
`;

const PlusButton = styled.span`
  position: relative;
  font-size: 24px;
  top: 2px;
  right: 5px;
`;
class NewDealButton extends React.Component {
  
  handleNewDealClick = () => {
    this.props.history.push("/newdeal");
  };

  render() {
    return (
      <Fragment>
        <OpenNewDealButton id="newDealButton" variant="contained" onClick={this.handleNewDealClick} >
          <Add/>
          <span>NEW DEAL</span>
        </OpenNewDealButton>
      </Fragment>
    );
  }
}

const mapStateToProps = () => ({});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    {
      showModal,
      hideModal,
    }
  )
)(NewDealButton);
